import React, { Component, PropTypes } from 'react';
import { browserHistory } from 'react-router';

import MoreMenu from './MoreMenu';

import './AppBar.css';

export default class AppBar extends Component {
    static propTypes = {
        logout: PropTypes.func.isRequired,
    }

    constructor(props) {
        super(props);

        this.handleSignOutClick = this.handleSignOutClick.bind(this);
    }

    handleSignOutClick() {
        this.props.logout();
    }

    render() {
        return (
            <div>
                <header className="app-bar">
                    <div className="logo"></div>
                    <MoreMenu>
                        <li onClick={this.handleSignOutClick}>Sign out</li>
                    </MoreMenu>
                </header>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./scripts/components/Common/AppBar.jsx